import React from 'react'
import "./blueRibbon.css"

interface BlueRibbonProps {
    desiredPoints: number
}

const blueRibbon = ({ desiredPoints }: BlueRibbonProps) => {
  return (
    <React.Fragment>
        <div className="blue-bookmark">
            <div className="blue-bookmark-text">
                <h4>ขาดเพียง</h4>
                <h4>{desiredPoints} คะแนน</h4>
            </div>
        </div>
    </React.Fragment>
    )
}

export default blueRibbon;
